import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"
import type { AudienceCheckNameResponse, AudienceCompareResponse, AudienceCopyResponse, AudienceCreateResponse, AudienceExportResponse, AudienceInfoResponse, AudienceListResponse, AudienceStatusListResponse, AudienceTypeListResponse, AudienceUpdateResponse, FilterConditionChoicesResponse, FilterConditionsResponse } from "./types"

// 取得受眾列表
export function getAudienceList(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceListResponse>({
        url: "/audiences/",
        method: "get",
        ...config,
    })
}

// 創建新受眾
export function createAudience(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceCreateResponse>({
        url: "/audiences/",
        method: "post",
        ...config,
    })
}

// 複製受眾
export function duplicateAudience(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<AudienceCopyResponse>({
        url: `/audiences/${audienceId}/copy/`,
        method: "post",
        ...config,
    })
}

// 取得受眾資訊
export function getAudienceInfo(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<AudienceInfoResponse>({
        url: `/audiences/${audienceId}/`,
        method: "get",
        ...config,
    })
}

// 修改受眾資訊
export function editAudienceInfo(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<AudienceUpdateResponse>({
        url: `/audiences/${audienceId}/`,
        method: "put",
        ...config,
    })
}

// 停用此受眾
export function disableAudience(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/audiences/${audienceId}/disable/`,
        method: "post",
        ...config,
    })
}

// 刪除此受眾
export function deleteAudience(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/audiences/${audienceId}/`,
        method: "delete",
        ...config,
    })
}

// 取得條件列表
export function getFilterConditions(config: AxiosRequestConfig = {}) {
    return instance.request<FilterConditionsResponse>({
        url: `/audiences/filter-conditions/`,
        method: "get",
        ...config,
    })
}

// 取得條件列表子條件選項列表 目前僅有 dataType： List 、 String 會使用到這隻 API
export function getFilterConditionsChoices(
    audienceId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<FilterConditionChoicesResponse>({
        url: `/audiences/filter-conditions/${audienceId}/choices/`,
        method: "get",
        ...config,
    })
}

// 將受眾條件送出分析獲得 Job id
export function audiencesAnalyze(config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: "/audiences/analyze/",
        method: "post",
        ...config,
    })
}

// 將受眾條件送出分析
export function audiencesFetch(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/audiences/${uuid}/fetch/`,
        method: "get",
        ...config,
    })
}

// 受眾分析出來的 GID 表格
export function getAudiencesMember(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/audiences/${uuid}/members/`,
        method: "get",
        ...config,
    })
}

// 下載名單
export function exportAudiences(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request<AudienceExportResponse>({
        url: `/audiences/${uuid}/export/`,
        method: "post",
        ...config,
    })
}

// 取得受眾分析比較結果
export function compareAudiences(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceCompareResponse>({
        url: `/audiences/compare/`,
        method: "post",
        ...config,
        timeout: 0,
    })
}

// 確認受眾名稱是否重複
export function checkAudienceName(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceCheckNameResponse>({
        url: `/audiences/name-check/`,
        method: "post",
        ...config,
    })
}

// 取消受眾計算
export function cancelAudienceCalculate(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/audiences/${uuid}/cancel-calculation/`,
        method: "post",
        ...config,
    })
}

// 受眾再分群
export function splitAudience(uuid: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/audiences/${uuid}/split/`,
        method: "post",
        ...config,
    })
}

// 取得受眾類型
export function getAudienceType(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceTypeListResponse>({
        url: "/audiences/type/",
        method: "get",
        ...config,
    })
}

// 取得受眾狀態
export function getAudienceStatus(config: AxiosRequestConfig = {}) {
    return instance.request<AudienceStatusListResponse>({
        url: "/audiences/status/",
        method: "get",
        ...config,
    })
}
